const RankStandard = {
  S: 235,
  A: 210,
  B: 185,
}
export default RankStandard
